<script setup>
defineProps(["badge"]);
</script>

<template>
	<div class="achievement-item z-image relative flex h-16 w-16 items-center justify-center rounded-full border border-border-default bg-bg p-1">
		<img :src="badge.icon" alt="achievement icon" />

		<div class="tooltip absolute top-[120%] z-[10000] hidden w-[10rem] flex-col gap-3 rounded-max bg-neutral-500 p-5 text-center lg:w-[15rem]">
			<p class="md">{{ badge.name }}</p>
			<p class="md opacity-70" v-if="badge.description">{{ badge.description }}</p>
		</div>
	</div>
</template>

<style scoped>
.achievement-item:hover > .tooltip {
	@apply flex;
}
</style>
